// @flow
import { handleActions } from "redux-actions";
import Record from "../flow/Record";
import { jsToPostRecord, Post } from "../records/post.record";
import {
    fetchPost,
    fetchPostFailure,
    fetchPostSuccess
} from "../actions/viewPost.actions";
import { RequestState } from "../records/request.record";
import { setupRequest } from "./request.reducer";
import { togglePostReactionSuccess } from "../actions/post.actions";
import {
    deleteCorrectionSuccess,
    reportCorrectionSuccess,
    submitCommentSuccess,
    submitCorrectionSuccess,
    toggleCorrectionReactionSuccess
} from "../actions/correction.actions";

export class ViewPost extends Record({
    post: new Post(),
    requestPost: new RequestState()
}) {
    post: Post;
    requestPost: RequestState;
}

const requestReducer = setupRequest("requestPost");

const updateCorrection = (state, { payload: { correction } }) => {
    if (state.post.id === correction.postId) {
        let found = false;
        let newCorrections = state.post.corrections.map(c => {
            if (c.id === correction.id) {
                found = true;
                return correction;
            }
            return c;
        });

        if (!found) {
            newCorrections = newCorrections.push(correction);
        }
        state = state.merge({
            post: state.post.merge({
                corrections: newCorrections
            })
        });
    }
    return state;
};

const deleteCorrection = (state, { payload: { correction } }) => {
    if (state.post.id === correction.postId) {
        return state.merge({
            post: state.post.merge({
                corrections: state.post.corrections.filter(
                    c => c.id !== correction.id
                )
            })
        });
    }
    return state;
};

const viewPost = handleActions(
    {
        [fetchPost](state, { payload: { id } }) {
            state = requestReducer.start(state);
            if (id !== state.post.id) {
                return state.set("post", new Post());
            }
            return state;
        },
        [fetchPostFailure]: requestReducer.failure,
        [fetchPostSuccess](state, { payload: { post } }) {
            return requestReducer
                .success(state)
                .merge({ post: jsToPostRecord(post) });
        },
        [togglePostReactionSuccess](state, { payload: { post } }) {
            if (state.post.id === post.id) {
                return state.merge({ post });
            }
            return state;
        },
        [toggleCorrectionReactionSuccess]: updateCorrection,
        [submitCommentSuccess]: updateCorrection,
        [submitCorrectionSuccess]: updateCorrection,
        [deleteCorrectionSuccess]: deleteCorrection,
        [reportCorrectionSuccess]: deleteCorrection
    },
    new ViewPost()
);

export default viewPost;



// WEBPACK FOOTER //
// ./src/reducers/viewPost.reducer.js